export default {
  name: 'Header section - 18',
  tab: 'header',
  type: 'navigation-default-section',
  content: {
    logo: '/storage/media/Logo/combination_logo_outline_transparent.svg',
    menu: '1'
  },
  design: {
    'background-color': 'var(--primary-color)',
    padding: '15px',
    'logo-width': '150',
    'menu-font-family': 'inherit',
    'menu-text-color': 'inherit',
    'menu-font-size': '14'
  },
  layout: {
    'content-container-fluid': '0',
    centered: '1',
    absolute: '0',
    'absolute-background-opacity': '0',
    'show-toggle': 'sm'
  },
  advanced: {
    'stick-on-scroll': '0',
    'sticky-background-color': 'var(--secondary-color)',
    'sticky-background-opacity': '1',
    'active-style': 'default'
  }
}
